export default __webpack_public_path__ + "static/media/failed_validation.1fb1d39a.png";